export default __webpack_public_path__ + "static/media/priority_critical.ab66e1fc.svg";